<template>
	<div class="form_box">
		<el-table :empty-text="langtrans().zwmsss[languageIndex]" :data="tableData" border>
			<el-table-column prop="number" :label="langtrans().xhh[languageIndex]" min-width="50%">
			</el-table-column>
			<el-table-column :label="langtrans().ajbhh[languageIndex]" min-width="80%">
        <template slot-scope="scope">
            {{scope.row.casenumber}}
            <span v-if="scope.row.subRegulatorId != null && scope.row.subRegulatorId != '' && scope.row.subRegulatorId != undefined">({{scope.row.subRegulatorId}})</span>
          </template>
			</el-table-column>
			<el-table-column prop="address" :label="langtrans().ffsddd[languageIndex]" min-width="100%">
			</el-table-column>
			<el-table-column prop="username" :label="langtrans().yhxm[languageIndex]" min-width="50%">
			</el-table-column>
			<el-table-column prop="phone" :label="langtrans().yhsjhh[languageIndex]" min-width="70%">
			</el-table-column>
			<el-table-column prop="papers" :label="langtrans().zjxsxx[languageIndex]" min-width="80%">
			</el-table-column>
			<el-table-column prop="sex" :label="langtrans().xbb[languageIndex]" min-width="50%">
			</el-table-column>
			<el-table-column v-if="typeId != 800" prop="time" :label="langtrans().cxsjj[languageIndex]" min-width="90%">
			</el-table-column>
      <el-table-column v-else prop="time" label="预期服务时间" min-width="90%">
			</el-table-column>
			<el-table-column prop="par" :label="langtrans().yhbxxq[languageIndex]" min-width="70%">
				<template slot-scope="scope">
					<el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">{{langtrans().bxxqq[languageIndex]}}</el-button>
					<el-button type="text" size="small" v-show="!scope.row.isshow">{{langtrans().wm[languageIndex]}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="plan" :label="langtrans().ddqjdd[languageIndex]" min-width="80%">
			</el-table-column>
			<el-table-column prop="node" :label="langtrans().ddqjjd[languageIndex]" min-width="60%">
			</el-table-column>
			<el-table-column prop="get_time" :label="langtrans().qdjysj[languageIndex]" min-width="90%">
			</el-table-column>
			<el-table-column prop="op" :label="langtrans().cczzz[languageIndex]" min-width="110%">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="topar(scope.row)">{{langtrans().czkkbb[languageIndex]}}</el-button>
				</template>
			</el-table-column>
		</el-table>
     <el-pagination
      style="margin-top: 15px;float: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[20]"
      :page-size="20"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
	</div>
</template>

<script>
	import langtrans from "./js/form.vue.trans.js";
	import { Message } from "element-ui";
	import "isomorphic-fetch";
	import constants from "@/util/constants.js";
	import Promise from 'promise-polyfill';//getAwaitData
	import { getAwaitData } from '@/views/axios/api.js';

	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		props: ["token", "st_time", "en_time", "sereen", "typeId", "caseNo"],
		data() {
			return {
        start:0,
        count:20,
        total:0,
        currentPage4: 1,
				tableData: [],
				obj: [],
				victimList: [],
			};
		},
		methods: {
         handleSizeChange(val) {
         this.count = val
             this.getData()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.start = (val-1) * this.count;
        // this.start = val * 10
            this.getData()
        console.log(`当前页: ${val}`);
      },
			langtrans() {
				return langtrans
			},
			topar(data) {
        console.log(data)
				let that = this;
				console.log(that.obj);
				this.$router.push({
					name: "Par",
					params: {
						token: that.token,
					},
					query: {
						typeId: that.typeId,
						caseid: data.caseid,
					}
				});
			},

			toUrl(url) {
				//window.open(url);
			},
			getData(st, et) {
				this.tableData = [];
				let n = 0;
				let sex = "";
				let isshow = false;
				var data={
					token:JSON.parse(window.localStorage.getItem("data")).data,
					typeId:this.typeId,
					status:140,
					submit:0,
					startTs:this.st_time,
					endTs:this.en_time,
          start:this.start,
         count:this.count,
         caseNo:this.caseNo				
				}
				getAwaitData(data)
					.then(data => {
						var data=data.data;
						this.tableData=[]
            console.log(data.total)
            this.total = data.total
						if(data.obj) {
							data.obj.map(v => {
								if(v == null)
									return;
								if(!v.solutionState) {
									n = n + 1;
									if(this.languageIndex == 0){
										if(v.victimList[0].obj.gender == 1) {//汉语
											sex = "男";
										} else {
											sex = "女";
										}										
									}else{
										if(v.victimList[0].obj.gender == 1) {//汉语
											sex = "Male";
										} else {
											sex = "Female";
										}										
									}

									if(
										v.victimList[0].obj.insurancePaper &&
										v.victimList[0].obj.insurancePaper != ""
									) {
										isshow = true;
									} else {
										isshow = false;
									}

									var pt = constants.pt2txt(v.obj.caseState);
									if(v.solutionState == 3) {
										pt.phase = this.langtrans().zzzhzz[this.languageIndex];
										pt.node =  this.langtrans().bjjjyg[this.languageIndex];
									}
									if(this.languageIndex == 1){									
										pt.phase = pt.phaseEn
										pt.node = pt.nodeEn
									}
									var address=''
									if(v.generalLocation){
										if(!constants.setTxt(v.generalLocation.addr,'zh')){
											address=v.generalLocation.addr
										}else{
											address=this.languageIndex== 0 ? constants.setTxt(v.generalLocation.addr,'zh') : constants.setTxt(v.generalLocation.addr,'en')
										}
									}																				
									this.tableData.push({
										number: n, //序号
										caseid: v.obj.id,
										casenumber: v.obj.caseNo, //案件编号
										address, //地址
										username: constants.strHidden(v.victimList[0].obj.victimName, 1), //姓名
										phone: constants.strHidden(v.obj.reporterContact), //联系方式
										papers: constants.strHidden(v.victimList[0].obj.idNo) || "无", //身份证号
										sex: sex, //性别
										time: constants.time(v.obj.incidentTs), //出险时间
										isshow: isshow, //保单
										insuranceUrl: v.insuranceUrl,
										plan: pt.phase, //进度
										node: pt.node, //节点
										get_time: constants.time(v.rescueInitTs),
                    subRegulatorId: v.obj.subRegulatorId,
										op: this.langtrans().czkkbb[this.languageIndex]
									});
									this.obj.push(v.obj);
									this.victimList.push(v.victimList[0]);
								}
							});
						}
					});
			}
		},
		watch: {
			en_time(nv, ov) {
				console.log(nv, ov);
				// this.getData(0, nv + 86400000);
				if(this.en_time + 86400000 < this.st_time && this.en_time != "") {
					Message.error(this.langtrans().jjssjj[this.languageIndex]);
				}
				//  this.getData(this.st_time, this.en_time + 86400000);
			},
			st_time(nv, ov) {
				console.log(nv, ov);
				if(this.en_time + 86400000 < this.st_time && this.en_time != "") {
					Message.error(this.langtrans().jjssjj[this.languageIndex]);
				}
				// this.getData(nv, 0);
				//  this.getData(this.st_time, this.en_time + 86400000);
			},
			sereen(nv, ov) {
				console.log(nv);
				if(nv) {
					this.getData(this.st_time, this.en_time + 86400000);
				}
			},
			caseNumber(nv, ov) {
				console.log('案件编号变化:', nv);
				this.getData();
			},
			languageIndex(){
				this.getData()
			}
		},

		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		},
		mounted() {
			if(this.st_time == "" && this.en_time == "") {
				this.getData();
			}
		}
	};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/fac/form.vue